<div #pageWrapper>
    <ham-table-with-actions
        [dataSource]="workflows"
        [pageSize]="10"
        [columnClasses]="['hamTextCol', 'hamDateCol', 'hamTextCol']"
        hideActions="true"
        showActionsInRowsOnly="true"
        (rowSelected)="onRowSelected($event)"
        [pagination]="false"
    >
        <ng-template hamHeaderCell>
            {{ 'aumico_cpmm_closing_workflows_table_title_label' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell>
            {{ 'aumico_cpmm_closing_workflows_table_creation_date_label' | i18next }}
        </ng-template>

        <ng-template hamCell let-element> {{ element?.name || '-' }} </ng-template>
        <ng-template hamCell let-element>
            {{ element?.createdAt ? (element.createdAt | dateLocale) : '-' }}
        </ng-template>

        <ng-template hamMenuButton let-element>
            <span
                hamIconShapes
                icon="assets/hamIcons/trash-outline.svg"
                [variant]="'transparent'"
                [size]="'xs'"
                [mustBubbleEvent]="true"
                (click)="onDeleteClick(element.workflowId, $event)"
            >
            </span>
        </ng-template>
    </ham-table-with-actions>
</div>
<ham-confirm-decline-modal
    *ngIf="openWorkflowDeletionConfirmationDialog"
    (cancel)="onCancelWorkflowDeletion()"
    (action)="onDeleteRow()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_cpmm_closing_workflows_table_delete_workflow_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
